import { render, staticRenderFns } from "./color.vue?vue&type=template&id=734d5bd8&scoped=true&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"
import style0 from "./color.vue?vue&type=style&index=0&id=734d5bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734d5bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734d5bd8')) {
      api.createRecord('734d5bd8', component.options)
    } else {
      api.reload('734d5bd8', component.options)
    }
    module.hot.accept("./color.vue?vue&type=template&id=734d5bd8&scoped=true&", function () {
      api.rerender('734d5bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/color.vue"
export default component.exports